import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
	state,
	mutations,
	actions,
	getters,
	modules: {},
	filter: mutation => {
		return [
			// clientDetails,
			// clientSettings,
			// userClasses,
			// userClassId,
			// userClassLocations,
			// selectedLocation,
			// selectedAssetLocations,
			// selectedAssetLocation,
			// selectedDate,
			// openingHoursForDate,
			// currentRooms,
			// roomDetailsById,
			// assetCategory,
			// assetGroup,
			// assetType,
			// asset,
			// HTMLWidget,
			// locations,
			// showMap,
			// isLoading
		].includes(mutation.type);
	}
};

// import Vue from 'vue';
// import Vuex from 'vuex';
// Vue.use(Vuex);

// import VuexPersist from 'vuex-persist';
// const vuexPersist = new VuexPersist({
// 	key: 'communico',
// 	storage: window.localStorage
// });

// import state from './state';
// import mutations from './mutations';
// import actions from './actions';
// import getters from './getters';

// export default new Vuex.Store({
// 	plugins: [vuexPersist.plugin],
// 	state,
// 	mutations,
// 	actions,
// 	getters,
// 	modules: {}
// });
